import { chatQueryKeys as e } from "./useChatQueryKeys.mjs";
import { useQuery as t, useQueryClient as n } from "@maat/store-hooks";
import { chatApi as r } from "@maat/api-chat";
//#region src/hooks/useConversationQuery.ts
var i = 6e4, a = (t, n) => {
	let r = t.getQueryCache().findAll({ queryKey: e.conversations() });
	for (let e of r) {
		let t = e.state.data;
		if (t) for (let r of t.pages) {
			let t = r.conversations.find((e) => e.id === n);
			if (t) return {
				data: { conversation: t },
				updatedAt: e.state.dataUpdatedAt
			};
		}
	}
}, o = (o, s) => {
	let c = n(), l, u = !1, d = () => (u || (u = !0, l = o ? a(c, o) : void 0), l);
	return t({
		queryKey: e.conversation(o ?? ""),
		queryFn: () => r.getConversation(o),
		enabled: !!o && (s?.enabled ?? !0),
		initialData: () => d()?.data,
		initialDataUpdatedAt: () => d()?.updatedAt,
		staleTime: i
	});
};
//#endregion
export { o as useConversationQuery };
